import Vue from "vue";
import TitleMixin from "@/mixins/title";
import SpinnerMixin from "@/mixins/spinner";
import OfficeEditTemplate from "@/components/Templates/Users/OfficeEditTemplate.vue";
import { CommandColumn, Edit, Sort, Toolbar } from "@syncfusion/ej2-vue-grids";
import { mapGetters } from "vuex";
import { Role } from "@/config/role";
export default Vue.extend({
    mixins: [TitleMixin, SpinnerMixin],
    data() {
        return {
            title: this.$t("users.edit.title"),
            id: this.$route.params.id,
            user: {},
            employees: [],
            roles: [],
            officesGrid: {
                editSettings: {
                    allowEditing: true,
                    allowAdding: true,
                    allowDeleting: true,
                    mode: "Dialog",
                    template: function () {
                        return {
                            template: Vue.component("office-user-item", OfficeEditTemplate)
                        };
                    }
                },
                commands: [
                    /*
                    {
                      type: "Edit",
                      buttonOption: { cssClass: "e-flat", iconCss: "e-edit e-icons" }
                    },
                    */
                    {
                        type: "Delete",
                        buttonOption: { cssClass: "e-flat", iconCss: "e-delete e-icons" }
                    }
                ],
                toolbar: ["Add"],
                sortOptions: {
                    columns: [{ field: "officeName", direction: "Ascending" }]
                },
                validationOptions: {
                    rules: {
                        officeId: {
                            required: true
                        },
                    }
                }
            },
            validationOptions: {
                rules: {
                    email: {
                        required: true,
                        email: true,
                        rangeLength: [3, 100]
                    },
                    firstName: {
                        required: true,
                        rangeLength: [1, 100]
                    },
                    lastName: {
                        required: true,
                        rangeLength: [1, 100]
                    },
                    roleId: {
                        required: true
                    }
                }
            }
        };
    },
    provide: {
        grid: [Sort, Edit, Toolbar, CommandColumn]
    },
    computed: {
        ...mapGetters({
            hasMultipleOffices: "account/hasMultipleOffices",
            getSingleOfficeId: "account/getSingleOfficeId"
        }),
        showOfficesGrid() {
            if (!this.hasMultipleOffices)
                return false;
            if (this.user.roleId == null)
                return false;
            if (this.user.roleId === Role.AdministratorId)
                return false;
            return true;
        }
    },
    methods: {
        officesGridActionBegin(args) {
            if (args.requestType === "save") {
                args.data["officeName"] = args.form.querySelector("#officeId").value;
            }
        },
        officesGridActionComplete(args) {
            if (args.requestType === "beginEdit" || args.requestType === "add") {
                // Add Validation Rules
                const userOffices = this.user.offices;
                args.form.ej2_instances[0].addRules("officeId", {
                    exists: [
                        function (args) {
                            const officeIdOld = args.element.form.querySelector("#officeIdOld").value;
                            if (args.value == officeIdOld)
                                return true;
                            return !userOffices.some(office => office.officeId == args.value);
                        },
                        this.$t("offices.officeExists")
                    ]
                });
                args.dialog.width = 380;
                if (args.requestType === "add") {
                    args.dialog.header = this.$t("offices.newOffice");
                }
                else {
                    args.dialog.header = this.$t("offices.editOffice", {
                        name: args.rowData["officeName"]
                    });
                }
            }
        },
        edit() {
            return this.$store.dispatch("user/edit", {
                id: this.id,
                user: this.user
            });
        },
        editSuccess() {
            this.$toast.showSuccessToast(this.$t("users.edit.toastSuccessTitle"), this.$t("users.edit.toastSuccessContent", {
                name: `${this.user.firstName} ${this.user.lastName}`
            }));
            return this.$router.push("/administration/users");
        },
        cancel() {
            return this.$router.push("/administration/users");
        }
    },
    async mounted() {
        this.showSpinner();
        try {
            const offices = await this.$store.dispatch("office/getAll", {
                load: true
            });
            this.employees = await this.$store.dispatch("employee/getAll", {
                load: true
            });
            this.employees.forEach((employee) => (employee.fullName = `${employee.name} ${employee.surname}`));
            this.roles = await this.$store.dispatch("user/getRoles");
            for (const role of this.roles)
                role.name = this.$t(role.name);
            this.user = await this.$store.dispatch("user/get", {
                id: this.id
            });
            for (const userOffice of this.user.offices) {
                const office = offices.find((office) => office.id === userOffice.officeId);
                if (office != undefined)
                    userOffice.officeName = office.name;
            }
            // Refresh grids to show updated data
            if (this.showOfficesGrid)
                this.$refs.userOfficesGrid.ej2Instances.refresh();
            //this.title += ` ${this.user.firstName} ${this.user.lastName}`;
            this.hideSpinner();
        }
        catch (errors) {
            this.hideSpinner();
            this.$toast.showDangerToast(this.$t("shared.toastFailureTitle"), this.$t("shared.toastFailureContent", {
                error: errors[0].message
            }));
            await this.$router.push("/administration/users");
        }
    }
});
